module.exports = "<p>\n  smart-booking-bar works!\n</p>\n"